import { getAcessToken } from '@/modules/shared/storage';
export const relatorio = async(params) => {
  const url = `${process.env.VUE_APP_RELATORIO_URL}/relatorio?${new URLSearchParams(params).toString()}`;
  const response = await fetch(url, {
    responseType: 'blob',
    headers: { Authorization: `bearer ${getAcessToken()}` },
  });
  const blob = response.blob();
  return blob;
};
export const blobToBase64 = async(blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};
